import $ from 'jquery';
import { Swiper, Pagination, EffectCreative, Autoplay } from "swiper";
export class Hero {
    constructor() {
        this.selector = '.hero';
        if ($(this.selector).length === 0)
            return;
        $(this.selector).each((_, element) => {
            const $swiper = $(element).find(".swiper");
            const $swiperPagination = $(element).find(".swiper-pagination .container");
            const $slides = $swiper.find(".swiper-slide");
            const swiper = new Swiper($swiper[0], {
                modules: [Pagination, EffectCreative, Autoplay],
                slidesPerView: 1,
                direction: "horizontal",
                grabCursor: true,
                effect: "custom",
                autoplay: true,
                longSwipesMs: 2000,
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: ["-20%", 0, -1],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                pagination: {
                    el: $swiperPagination[0],
                    clickable: true,
                },
                on: {
                    init: () => {
                        $slides.each((_, slide) => {
                            const $btns = $(slide).find("button");
                            if ($btns.length === 0)
                                return;
                            $btns.eq(0).addClass('is-active');
                            $btns.each((_, btn) => {
                                $(btn).on("click", () => {
                                    const { index } = $(btn).data();
                                    swiper.slideTo(parseInt(index));
                                });
                            });
                        });
                    },
                    slideChange: () => {
                        $slides.each((_, slide) => {
                            const $btns = $(slide).find("button");
                            $btns.each((_, btn) => {
                                $(btn).removeClass('is-active');
                            });
                            if ($btns[swiper.activeIndex]) {
                                $btns.eq(swiper.activeIndex).addClass('is-active');
                            }
                            ;
                        });
                    },
                },
            });
        });
    }
}
;
